export default __webpack_public_path__ + "locales/ar-SA/MainBar.json?hash=8883a251494597d658301c07b5cd3d72";